import React from "react";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { Button, Stack, TextField, Typography } from "@mui/material";

export default function MessageComposer({
  value,
  onChange,
  onSend,
  error = "",
  sending = false,
}) {
  const canSend = Boolean(String(value || "").trim()) && !sending;

  return (
    <Stack spacing={1.1}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={1.2} alignItems={{ md: "flex-end" }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Say something quick..."
          value={value}
          multiline
          maxRows={4}
          inputProps={{ maxLength: 280 }}
          disabled={sending}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault();
              if (canSend) onSend();
            }
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "18px",
              bgcolor: "#f7f9fc",
            },
          }}
        />
        <Button
          variant="contained"
          endIcon={<SendRoundedIcon />}
          onClick={onSend}
          disabled={!canSend}
          sx={{
            minWidth: 148,
            minHeight: 44,
            borderRadius: "999px",
            textTransform: "none",
            fontWeight: 700,
            bgcolor: "#17345d",
            "&:hover": { bgcolor: "#132b4e" },
          }}
        >
          {sending ? "Sending..." : "Send message"}
        </Button>
      </Stack>
      {error ? (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      ) : null}
    </Stack>
  );
}
